import { MobiDocument } from './MobiDocument';

export class DossierDocument extends MobiDocument{
    private _id : string;
    private _rev : string;
    private id : number;
    private gestioninfosanitaire: boolean;
    private gestionchamplibre: boolean;

    public constructor(dossier: any){
        super()
        this._id = dossier._id;
        this._rev = dossier._rev;
        this.id = dossier.id;
        this.gestioninfosanitaire= dossier.gestioninfosanitaire;
        this.gestionchamplibre= dossier.gestionchamplibre;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public isGestioninfosanitaire(): boolean {
        return this.gestioninfosanitaire;
    }

    public setGestioninfosanitaire(gestioninfosanitaire: boolean): void {
        this.gestioninfosanitaire = gestioninfosanitaire;
    }

    public isGestionchamplibre(): boolean {
        return this.gestionchamplibre;
    }

    public setGestionchamplibre(gestionchamplibre: boolean): void {
        this.gestionchamplibre = gestionchamplibre;
    }


}